export default __webpack_public_path__ + "static/portugal2020-01baa0cb1129eb6ccec419c23e54fbe1.jpg";